export default "__VITE_ASSET__BON1rvr2__"